var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSublevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M221.6,160.8h-87.3c-11.5,0-20.8,9.1-20.8,20.3v5.2H75.3c-6.6,0-11.1-2-13.8-6c-2-2.9-2.5-6-2.6-6.8V64.2h-18V174 c0,0.2,0,0.3,0,0.5c0,0.8,0.6,7.8,5,15c4.2,6.8,12.8,15,29.4,15h38.2v1.8c0,11.2,9.3,20.3,20.8,20.3h87.3 c11.5,0,20.8-9.1,20.8-20.3v-25.1C242.4,169.9,233,160.8,221.6,160.8z M224.9,206.2c0,1.6-1.5,2.9-3.3,2.9h-87.3 c-1.9,0-3.3-1.3-3.3-2.9v-25.1c0-1.6,1.5-2.9,3.3-2.9h87.3c1.9,0,3.3,1.3,3.3,2.9V206.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,54.4c0-5.4-4.9-9.8-11-9.8H17.8c-6,0-11,4.4-11,9.8s4.9,9.8,11,9.8h99.3C123.1,64.2,128,59.8,128,54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.1,109.3h26.4v26.9c0,8.8,6,16,13.4,16s13.4-7.2,13.4-16v-26.9h26.5c8.8,0,16-5.8,16-12.9s-7.2-12.9-16-12.9h-26.4 v-27c0-8.8-6-16-13.4-16s-13.4,7.2-13.4,16v26.9h-26.4c-8.8,0-16,5.8-16,12.9C122.1,103.5,129.3,109.3,138.1,109.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSublevel);
export default __webpack_public_path__ + "static/media/sublevel.0d890c703461c126230b9ada67911781.svg";
export { ForwardRef as ReactComponent };